import type { SelectedFilter } from "~/components/build/Show/components/Filter/types";

export function isSelected(
  selected: SelectedFilter[],
  categoryKey: string,
  value: string,
): boolean {
  return selected.some((filter) => filter.categoryKey === categoryKey && filter.value === value);
}

export function toggleFilter(
  selected: SelectedFilter[],
  categoryKey: string,
  value: string,
): SelectedFilter[] {
  if (isSelected(selected, categoryKey, value)) {
    return selected.filter(
      (filter) => !(filter.categoryKey === categoryKey && filter.value === value),
    );
  }
  return [...selected, { categoryKey, value }];
}

export function removeFilter(
  selected: SelectedFilter[],
  categoryKey: string,
  value: string,
): SelectedFilter[] {
  return selected.filter(
    (filter) => !(filter.categoryKey === categoryKey && filter.value === value),
  );
}

export function removeAllInCategory(
  selected: SelectedFilter[],
  categoryKey: string,
): SelectedFilter[] {
  return selected.filter((filter) => filter.categoryKey !== categoryKey);
}
